var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteTraffic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2241 20.9131L13.5272 21.805C12.9657 22.1001 12.2853 22.0509 11.7721 21.6779C11.2589 21.305 11.0019 20.6731 11.1092 20.0478L11.4332 18.1592C11.5259 17.6187 11.3468 17.0672 10.9542 16.6843L9.58114 15.345C9.12705 14.9022 8.96372 14.2399 9.15982 13.6367C9.35591 13.0334 9.87743 12.5938 10.5051 12.5026L12.4019 12.2269C12.9448 12.148 13.4141 11.8069 13.6568 11.3149L14.5048 9.59601C14.7855 9.02694 15.365 8.66663 15.9995 8.66663C16.6341 8.66663 17.2136 9.02694 17.4943 9.59601L18.3422 11.3149C18.5849 11.8069 19.0542 12.148 19.5971 12.2269L21.4939 12.5025C22.1216 12.5938 22.6431 13.0334 22.8392 13.6366C23.0353 14.2399 22.872 14.9021 22.4179 15.345L21.0448 16.6843",
    stroke: "#EF233C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16C4 22.6274 9.37258 28 16 28",
    stroke: "#2B2D42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.37258 4 4 9.37258 4 16",
    stroke: "#2B2D42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8305 17.8305C27.9368 17.226 27.9935 16.6138 28 16C28 9.37258 22.6274 4 16 4",
    stroke: "#2B2D42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1828 24.5252L24.8711 25.4967C24.5534 25.6302 24.3007 25.8829 24.1671 26.2005L23.1925 28.5169C22.9739 29.0366 22.4519 29.3626 21.889 29.3311C21.3261 29.2995 20.8438 28.9173 20.6845 28.3765L18.7223 21.7116C18.5845 21.2434 18.7134 20.7374 19.0585 20.3923C19.4035 20.0472 19.9095 19.9182 20.3777 20.056L27.0425 22.017C27.5835 22.1762 27.9658 22.6586 27.9973 23.2216C28.0288 23.7846 27.7026 24.3066 27.1828 24.5252V24.5252Z",
    stroke: "#2B2D42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteTraffic);
export default __webpack_public_path__ + "static/media/WebsiteTraffic.e64d9583d0fff63d780bfb2c270ef5b2.svg";
export { ForwardRef as ReactComponent };